import React, { useState } from 'react';
import { pickBy } from 'lodash';
import { AiOutlineEye } from 'react-icons/ai';

import Table from 'partial/components/Table';
import SearchBar from 'partial/components/input/SearchBar';
import Pagination from 'partial/components/Pagination';
import FormSelectStatic from '../components/FormSelectStatic';
import { useOpenViewTransaction } from '../modals/ViewTransaction';

import { useTransactions } from '../hooks';
import * as c from '../constant';

const labelClassName = 'whitespace-nowrap';
const contentClassName = 'whitespace-nowrap';

const INITIAL_STATE = {
  keyword: '',
  status: { label: '', value: '' },
  per_page: 15,
};

function DefaultPage() {
  const viewTransaction = useOpenViewTransaction();
  const [filter, setFilter] = useState(INITIAL_STATE);
  const [isLoading, data, meta] = useTransactions(
    pickBy({
      ...filter,
      status: filter?.status?.value,
    }),
  );

  const transactionTableFormat = [
    ...c.transactionTableFormat,
    {
      id: 'view',
      label: '',
      key: (item) => (
        <button
          type="button"
          onClick={() => viewTransaction(item)}
          className="p-px border-none hover:bg-primary text-primary hover:text-white rounded transition"
        >
          <AiOutlineEye className="w-4 h-4" />
        </button>
      ),
    },
  ].map((item) => ({
    ...item,
    labelClassName,
    contentClassName,
  }));

  return (
    <div className="h-full flex flex-col mt-8 bg-red">
      <div className="h-6 w-6 " />
      <div className="flex items-center space-x-5 mb-5">
        <SearchBar
          inputClassName="py-4"
          name="keyword"
          onChange={setFilter}
          value={filter.keyword}
        />
        <FormSelectStatic
          name="status"
          data={c.statusOptions}
          value={filter.status}
          onChange={setFilter}
        />
      </div>
      <div className="flex flex-col mb-10">
        <Table
          data={data}
          isLoading={isLoading}
          format={transactionTableFormat}
        />
      </div>
      <Pagination value={meta} onChange={setFilter} />
    </div>
  );
}

export default DefaultPage;
